'use strict';

var React = require('react');

var SvgAnalyticsBarStackedMinor = function SvgAnalyticsBarStackedMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 6a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-10Zm8 2h2v4h-2v-4Zm-4 0h-4v4h4v-4Z"
  }));
};

exports.SvgAnalyticsBarStackedMinor = SvgAnalyticsBarStackedMinor;
